import React from 'react';
import { certifications } from '../data/portfolioData';
import { FaCertificate } from 'react-icons/fa';
import Icon from './Icon';
import useScrollReveal from '../hooks/useScrollReveal';
import './Certifications.css';

const Certifications: React.FC = () => {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="certifications" className="section certifications" ref={ref}>
      <div className={`container ${isVisible ? 'revealed' : 'hidden-section'}`}>
        <h2 className="section-title">Certificazioni</h2>
        <p className="section-subtitle">
          Le certificazioni professionali che ho conseguito.
        </p>

        <div className="certifications-grid">
          {certifications.map((cert, index) => (
            <div
              key={cert.id}
              className="certification-card animate-fade-in-up"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="certification-icon">
                {cert.logo ? (
                  <img src={cert.logo} alt={`${cert.name} logo`} className="certification-logo" />
                ) : (
                  <Icon icon={FaCertificate} />
                )}
              </div>
              <div className="certification-info">
                <h3 className="certification-name">{cert.name}</h3>
                <p className="certification-issuer">{cert.issuer}</p>
                {cert.year && (
                  <span className="certification-year">{cert.year}</span>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;
